import { financeAPI, api } from "../../axios";

export const actions = {
  createObjectOfExpenditures(context, data) {
    return financeAPI.post("ObjectOfExpenditures/CreateObjectOfExpenditures", data);
  },
  getSingleObjectOfExpenditures(context, data) {
    return financeAPI.get(`ObjectOfExpenditures/${data}`);
  },
  getObjectOfExpendituresByPrexcAndCycle(context, { cycle, prexcId, fundSourceId }) {
    return financeAPI.get(`ObjectOfExpenditures/Prexc/${prexcId}/${fundSourceId}/${cycle}`);
  },
  getObjectOfExpendituresByFSAndCycle(context, { cycle, fundSourceId }) {
    return financeAPI.get(`ObjectOfExpenditures/FundSource/${fundSourceId}/${cycle}`);
  },
  removeObjectOfExpenditures(context, data) {
    return financeAPI.delete(`ObjectOfExpenditures/${data}`);
  },
  getAvailableAccount(context, { cycle, fundSourceId }) {
    return financeAPI.get(`ObjectOfExpenditures/Available/${fundSourceId}/${cycle}`);
  },
  getObjectOfExpendituresByFundSource(context, { fundSourceId, cycle, outcomeId }) {
    return financeAPI.get(`ObjectOfExpenditures/FundSource/${fundSourceId}/${outcomeId}/${cycle}`);
  },
  addFund(context, data) {
    return api.post("ObjectOfExpenditureTransaction/AddFund", data);
  },
  revertFund(context, data) {
    return api.post("ObjectOfExpenditureTransaction/Revert", data);
  },
  getSingleObjectOfExpenditureTransaction(context, data) {
    return api.get(`ObjectOfExpenditureTransaction/${data}`);
  },
  removeSingleObjectOfExpenditureTransaction(context, data) {
    return api.delete(`ObjectOfExpenditureTransaction/${data}`);
  },
  getObjectOfExpenditureTransactionByExpenditureId(context, data) {
    return api.get(`ObjectOfExpenditureTransaction/ObjectOfExpenditure/${data}`);
  },
  importPrePlanningToActual(context, { fundSourceId, cycle, financeTemplateId }) {
    return financeAPI.post(`ObjectOfExpenditures/Import/PrePlanning/${fundSourceId}/${cycle}/${financeTemplateId}`);
  },
};
